/**
 * @param {Array<Record<string, unknown>>} flat
 * @returns {Array<{ raw: Record<string, unknown>, children: any[] }>}
 */
export function buildCommentTree(flat) {
  if (!flat?.length) return [];
  const byId = new Map();
  flat.forEach((c) => {
    const id = c.postCommentId;
    if (!id) return;
    byId.set(id, { raw: c, children: [] });
  });
  const roots = [];
  flat.forEach((c) => {
    const id = c.postCommentId;
    if (!id) return;
    const node = byId.get(id);
    const pid = c.parentPostCommentId;
    if (pid && byId.has(pid)) {
      byId.get(pid).children.push(node);
    } else {
      roots.push(node);
    }
  });
  const sortByCreated = (a, b) =>
    new Date(a.raw.createdAt) - new Date(b.raw.createdAt);
  const sortRec = (n) => {
    n.children.sort(sortByCreated);
    n.children.forEach(sortRec);
  };
  roots.sort(sortByCreated);
  roots.forEach(sortRec);
  return roots;
}
